import { newsFeature } from './news.feature';

export const { selectNewsState, selectIsLoading, selectCachedResponse, selectResponse } = newsFeature;
